import React, { useState, useRef } from "react";
import { Link } from 'react-router-dom';
import config from "config";
import ReactHtmlParser from 'react-html-parser';
import { FileDownloadOutlined, Close, EditOutlined, AttachFileOutlined, PrintOutlined } from "@mui/icons-material";
import IconButton from '@mui/material/IconButton';
import "NOTICEBOARD/Components/Notices/NoticeView/NoticeView.css";
import { useReactToPrint } from "react-to-print";
import Spinner from "NOTICEBOARD/CommonResources/SpinnerLoader/Spinner";
import ButtonLoader from "NOTICEBOARD/CommonResources/ButtonLoader/ButtonLoader";
import { Workspaces } from '@mui/icons-material';
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// FUNCTION FOR NOTICE VIEW MODAL
const NoticeView = ({ setShowSideBarNoticeView, noticeViewObject, setGetIndividualNoticeDetails, fetchNoticeView }) => {
    let noticeObject = Object.values(noticeViewObject)[0];

    let noticeAttachments = noticeObject != undefined ? (noticeObject.attachment != '' ? noticeObject.attachment.split(',') : []) : [];

    // check whether extension is valid or not 
    const [allowedFileExtensions] = useState(['png', 'jpg', 'jpeg']);
    const [attachmentIndex, setAttachmentIndex] = useState(0);
    const componentRef = useRef();

    // METHOD FOR HANDLE PRINT NOTICE VIEW
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    // METHOD FOR SAVE ATTACHMENT FILE 
    const saveFile = (attachment) => {
        saveAs(
            noticeObject.attachmentPath + attachment,
            attachment
        );
    };

    return (
        <>
            <div id="sideBar">
                <div id="sideBarContainer">
                    <div className="sideBarHeader d-flex justify-content-center align-items-center">
                        <div style={ { cursor: "pointer" } }>
                            <Close className="mx-2" onClick={ () => setShowSideBarNoticeView(false) } />
                        </div>
                        <div className="p-1 flex-grow-1 text-center">
                            <p>Notice View</p>
                        </div>
                    </div>
                    {
                        fetchNoticeView ? 
                            <Spinner /> 
                        :
                            <div ref={ componentRef }>
                                <div className="college-info">
                                    <img className="response-college-logo" alt="college-logo" src={ config.instructorInfo.InstituteLogo } />
                                    <p className="response-college-name">{ ReactHtmlParser(config.instructorInfo.InstituteName) }</p>
                                </div>
                                <div className="row p-0">
                                    <div className="col-12 smallFont">
                                        <div className="row">
                                            <div className="my-1 px-0 col-md-11 col-sm-12">
                                                <h6 style={ { fontWeight: "bold", color: "black" } }>
                                                    {
                                                        (noticeObject && noticeObject.title) &&
                                                            noticeObject.title
                                                    }
                                                </h6>
                                                <div className="d-flex justify-content-between">
                                                    <p>By { (noticeObject && noticeObject.addedBy) && noticeObject.addedBy }</p>
                                                    <p className="secondaryColor">{ (noticeObject && noticeObject.formattedNoticeDate) && noticeObject.formattedNoticeDate }</p>
                                                </div>
                                            </div>
                                            <div className="p-0 col-md-1 col-sm-12 d-flex justify-content-end align-items-center">
                                                <div className="iconBg hideWhenPrint">
                                                    <PrintOutlined className='pointer' onClick={ handlePrint } />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='flex pl-2' style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                                        <Workspaces style={ { fontSize: '16px', color: '#BDBDBD', marginRight: '10px' } } />
                                        {
                                            (noticeObject && noticeObject.categoryName) && noticeObject.categoryName
                                        }
                                    </div>
                                    <div className=''>
                                        {
                                            (noticeObject && noticeObject.department) &&
                                            <div className="my-1 smallFont col-12 d-flex" style={ { gap: '15px', marginTop: 10 } }>
                                                {
                                                    noticeObject.department.split(',').map(department => {
                                                        return <li>{ department }</li>;
                                                    })
                                                }
                                            </div>
                                        }
                                    </div>
                                    <div className="col-12" style={ { marginTop: 10 } }>
                                        <p className="smallFont" style={ { wordSpacing: "5px", textAlign: 'justify' } }>

                                            {
                                                (noticeObject && noticeObject.description) &&
                                                ReactHtmlParser(noticeObject.description)
                                            }
                                        </p>
                                    </div>
                                    {
                                        (noticeObject && noticeAttachments.length > 0) &&
                                            <div className="col-12 attachment-view-details" style={ { marginTop: 10 } }>
                                                <div className="row attachment-list" style={ { gap: "20px" } }>
                                                    {
                                                        noticeAttachments.map((attachment, noticeAttachmentIndex) => {
                                                            return(
                                                                <>
                                                                    {
                                                                        allowedFileExtensions.includes(attachment.substring(attachment.lastIndexOf('.') + 1)) ?
                                                                            <div className="book d-flex justify-content-center align-items-center flex-column" style={{ backgroundImage: `url(${noticeObject.attachmentPath + attachment})`, border: noticeAttachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => setAttachmentIndex(noticeAttachmentIndex)}>
                                                                                <div className="flex-grow-1"></div>
                                                                                <div className="bookDownloadSection hideWhenPrint">
                                                                                    <FileDownloadOutlined className="downloadButton  pointer" onClick={ () => saveFile(attachment) } />
                                                                                </div>
                                                                            </div>
                                                                        :
                                                                            <div className="pdfBook d-flex flex-column" style={{ border: noticeAttachmentIndex == attachmentIndex ? '2px solid #0465AC' : 'none' }} onClick={() => setAttachmentIndex(noticeAttachmentIndex)}>
                                                                                <FontAwesomeIcon className="pdfIcon" icon={ ['fas', 'file-pdf'] } />
                                                                                <div className="bookDownloadSection hideWhenPrint">
                                                                                    <FileDownloadOutlined onClick={ () => saveFile(attachment) } className="downloadButton  pointer" />
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </>
                                                            );
                                                        })
                                                    }
                                                </div>
                                                {
                                                    noticeAttachments.length > 0 &&
                                                        <div className="attachment-preview hideWhenPrint">
                                                            {
                                                                allowedFileExtensions.includes(noticeAttachments[attachmentIndex].substring(noticeAttachments[attachmentIndex].lastIndexOf('.') + 1)) ?
                                                                    <img src={noticeObject.attachmentPath + noticeAttachments[attachmentIndex]} width="100%" height='100%' />
                                                                :
                                                                    <iframe src={noticeObject.attachmentPath + noticeAttachments[attachmentIndex]} width="100%" height='100%' />
                                                            }
                                                        </div>
                                                }
                                            </div>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </div>
        </>
    );
}

export default NoticeView;
